<template>
  <Apexchart
    width="100%"
    height="300"
    type="pie"
    :options="chartOptions"
    :series="series"
  />
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  id: { type: String, required: true },
  labels: { type: Array, required: true },
  seriesData: { type: Array, required: true },
  primaryColors: {
    type: Array,
    default: () => [
      "#06BC7E",
      "rgba(255, 69, 96, 0.80)",
      "rgba(119, 93, 208, 0.80)",
      "rgba(0, 143, 251, 0.80)",
    ],
  },
});

const generateColors = () => {
  if (
    Array.isArray(props.seriesData) &&
    props.seriesData?.some((item) => item.color)
  ) {
    return props.seriesData.map((item, index) => {
      if (item.color) {
        return item.color;
      }
      return props.primaryColors[index % props.primaryColors.length];
    });
  }

  return props.primaryColors;
};

const chartOptions = computed(() => ({
  chart: {
    id: props.id,
    toolbar: { show: false },
  },
  labels: props.labels,
  colors: generateColors(),
  dataLabels: {
    enabled: true,
    formatter: function (val) {
      return val.toFixed(1) + "%";
    },
    style: {
      fontSize: "12px",
      fontFamily: "Proxima Nova, sans-serif",
      fontWeight: 400,
    },
    dropShadow: {
      enabled: false,
    },
  },
  legend: {
    show: true,
    position: "bottom",
    horizontalAlign: "left",
    fontSize: "12px",
    fontFamily: "Proxima Nova, sans-serif",
    fontWeight: 400,
    markers: {
      size: 5,
      shape: "circle",
      strokeWidth: 0,
      offsetX: -4,
    },
    itemMargin: {
      horizontal: 10,
      vertical: 0,
    },
    onItemClick: {
      toggleDataSeries: true,
    },
    onItemHover: {
      highlightDataSeries: true,
    },
    labels: {
      colors: "#888",
      useSeriesColors: false,
    },
    offsetX: -16,
    offsetY: 4,
  },
  tooltip: {
    theme: "dark",
    y: {
      formatter: (value) =>
        Number.isInteger(value) ? value : value.toFixed(2),
    },
  },
  stroke: {
    width: 2,
    colors: ["transparent"],
  },
  plotOptions: {
    pie: {
      donut: {
        size: "0%",
      },
      expandOnClick: true,
      startAngle: 0,
      endAngle: 360,
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 300,
        },
        legend: {
          position: "bottom",
        },
      },
    },
  ],
}));

const series = computed(() => {
  if (
    Array.isArray(props.seriesData) &&
    props.seriesData?.some((item) => typeof item === "object")
  ) {
    return props.seriesData.map((item) =>
      typeof item === "object" ? item.value || item.data : item,
    );
  }
  return props.seriesData;
});
</script>
